const SHEDULE_API_URL = process.env.REACT_APP_SHEDULE_API_URL;

export { SHEDULE_API_URL };
